<div class="header">
    <div class="header-shader">
        <app-top-bar></app-top-bar>
        <app-header-navigation></app-header-navigation>
        <app-home-header-banner></app-home-header-banner>
    </div>
</div>